// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3rkIZ","footer":"ReportModalFilter_footer__IBeEe"};